//-------------------------------------------------------------------------------------
//                             Copyright(c) 2024
//-------------------------------------------------------------------------------------
//  Abstract:
//		基于i18n的多国语言切换表-中文表
//-------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------>
const zh_CN = {
	// 公共
	commom: {
		username: '用户名',
		usernamePlaceholder: '输入用户名/电子邮箱',
		password: '密码',
		passwordPlaceholder: '请输入密码',
		passwordLengthWram: '请输入至少8位长度的密码',
		passwordEmpty: '密码或确认密码不能为空',
		passwordNot: '密码不一致',
		confirmPassword: '确认密码',
		confirmPasswordPlaceholder: '确认密码',
		email: '电子邮箱',
		emailPlaceholder: '请输入电子邮箱',
		code: '验证码',
		codePlaceholder: '请输入验证码',
		emailError: '邮箱格式不正确',
		sendSuccess: '发送成功，请注意查收',
		sendCode: '获取验证码',
		codeError: '请输入验证码或邮箱格式不正确',
		close: '关闭',
		menu: '菜单',
		isnull:'无',
		saveSuccess:'保存成功',
		sysErr:'系统异常，请稍后重试',
		component:'组件',
		resource:'资源类型',
		language:'语言',
		category:'类别',
		deleteSucess: '删除成功',
		ok:'确定',
		cancel:'取消',
		select:'选择',
		date:'日期',
		add:'新增',
		downloadLoadingText:"请稍候...",
		view:'查看',
		selectPlaceholder:"请选择",
		editorPlaceholder:"请输入...",
		qsPlaceholder:"请输入您的问题...",
		productSeries:"产品系列",
		noPermission:"无权限！"
	},
	search:{
		product:"产品",
		package:"产品版本",
		document:"文档",
		train:"培训",
		faq:"常见问题",
		activity:"活动",
		keyPlaceholder:"请输入关键字进行搜索",
		category:"分类",
		categoryTitle:"类别",
		result_p1:"您在",
		result_p2:"中",
		result_p3:"搜索",
		result_p4:"共获得",
		result_p5:"个结果"
	},
	filter:{
		bynew:'最新发布',
		byold:'最早发布',
		bytitle:"按标题",
		byhits:'阅览量',
		byweight:'权重大小',
		search:'搜索',
		reset:'重置',
		searchPlaceholder:'请输入关键字进行搜索',
		page:'显示{a}-{b}  共 {c}',//显示1-10 共60
		pageSize:'{a}个/页'//10个/页
	},
	// 登录
	login: {
		title: '登录',
		titleTip: '登录到您的账户以管理您的个人中心',
		remmenber: '记住登录密码',
		forgotPassword: '忘记密码',
		registerNow: '立即注册',
		noAccount: '没有帐号',
		usernameEmpty: '用户名/密码不能为空',
		success: '登录成功'
	},
	//产品
	product:{
		package:"安装包",
		document:"文档",
		question:"常见问题",
		train:"培训视频",
		updateTime:"更新时间",
		relations:"相关产品",
		feedback:"问题反馈",
		feedbackInfo:"描述您在当前产品遇到了什么问题，可进行问题描述反馈给平台进行处理。",
		feedbackBtn:"立即反馈",
		knowledge:"知识库"
	},
	ipproduct:{
		ip:"IP产品"
	},
	// 注册
	register: {
		title: '注册',
		titleTip: '注册您的账户以管理您的个人中心',
		nextSetp: '下一步',
		backLogin: '返回登录',
		siteId: '输入Site ID',
		siteIdPlaceholder: '请输入Site ID',
		noSiteId: '没有Site ID',
		improveInformation: '完善个人信息',
		tRIAL: '申请试用',
		loginTip: '稍后在个人中心完善，直接',
		tRIALTip: '请完善您的个人资料并选择感兴趣的产品',
		company: '您的公司',
		companyPlaceholder: '请输入您的公司名称',
		name: '您的名',
		namePlaceholder: '请输入您的名',
		surname: '您的姓',
		surnamePlaceholder: '请输入您的姓氏',
		country: '您的国家',
		countryPlaceholder: '请选择您的国家',
		province: '您的州/省',
		provincePlaceholder: '请选择您的州/省',
		city: '您的城市',
		cityPlaceholder: '请选择您的城市',
		encoded: '所在地邮政编码',
		encodedPlaceholder: '请输入邮政编码',
		address: '详细地址',
		addressPlaceholder: '请输入详细地址',
		companyAddress: '公司详细地址',
		companyAddressPlaceholder: '请输入公司详细地址',
		contact: '联系方式',
		contactPlaceholder: '请输入联系方式',
		interestedProduct: '感兴趣的产品',
		siteIdError: '请输入Site ID',
		saveLogin: '保存成功，返回登录',
		save:"保存"
	},
	// 找回密码
	findPassword: {
		title: '找回密码',
		titleTip: '根据邮箱进行密码找回',
		newPassword: '输入新密码',
		submit: '提交修改',
		changeSuccess: '修改成功'
	},
	// 头部菜单
	topMenu: {
		product: '产品',
		documentDownload: '知识文档',
		onlineTraining: '在线培训',
		frequentlyAskedQuestion: '常见问题',
		activity: '活动',
		operationTraining: '操作培训'
	},
	feedback:{
		process1:'提交反馈',
		process2:'资料审核',
		process3:'处理结果',
		questionType:"问题类型",
		selectQuestionType:"选择产品和问题类型",
		selectType:"选择类型",
		required:"备注*号的为必填项目",
		productName:"产品名称",
		selectProductName:"选择产品名称",
		version:"版本号",
		selectVersion:"选择版本号",
		basicInformation:"问题基本资料",
		tip:"提供更详细的资料以便做出更准确的了解您的需求。",
		questionDesc:"问题概述",
		titlePlaceholder:"请输入标题",
		content:"详细描述",
		contentPlaceholder:"请描述您的问题",
		additionalInformation:"补充资料",
		additionalInformationTip:"补充材料是与问题直接相关的信息资源。",
		attachments:"上传附件",
		uploadImage:"添加附件",
		submit:"立即提交",
		enterProductName: '请选择产品名称',
		selectVision: '请选择版本号',
		selectQuestionType: '请选择问题类型',
		writeQuestion:'请填写问题概述',
		writeDetail: '请填写详细描述',
		adminExamine: '提交成功，等待管理员审核',
		problemDesc:'问题描述',
		submitDate:"提交日期",
		type:'问题类型',
		attach:'附件',
		ExpectedPriority:'问题严重程度',
		ExpectedResolutionTime:"期望解决时间",
		updateTime:'更新时间',
		createDate:"创建时间",
		proName:"产品名称版本号",
		productOrIp:"产品名称"
	},
	// 前台
	show: {
		newProduct: '最新产品',
		more: '更多',
		newDocument: '最新文档',
		newTrain: '最新培训',
		newActivity: '最新活动',
		noStart: '未开始',
		entrying: '报名中',
		end: '已结束',
		lookDetail: '查看详细',
		category:'分类',
		brief:"简介",
		relatedDownloads:'相关下载',
		prev:'上一篇',
		next:'下一篇',
		directory:'目录',
		relatedTraining:'相关培训',
		loginAndRegister:"登录/注册",
		activityDate:"活动日期",
		registrationDate:"报名日期",
		activityType:"活动类型",
		offlineActivity:'线下活动',
		onlineActivity:'线上活动'

	},
	activity:{
		notStarted:'未开始',
		inProgress:"报名中",
		ended:"已结束",
		resource:"文章来源",
		eventRegistration:"活动报名",
		tip:"填写表格以报名参加活动",
		requireTip:"( 备注*号为必填内容 )",
		name:"姓名",
		namePlaceholder:"请输入姓名",
		phone:"手机号",
		phonePlaceholder:"请输入手机号",
		email:"企业邮箱",
		emailPlaceholder:"请输入企业邮箱",
		emailRex:"邮箱格式不正确",
		company:"公司",
		companyPlaceholder:"请输入公司名称",
		post:"职位",
		selectPost:"请选择职位",
		industry:"行业",
		selectIndustry:"请选择行业",
		aggree:"我阅读并同意",
		aggreeName:"合见工软服务条款",
		aggreed:"我已阅读并同意",
		submit:"立即报名",
		close:"关闭",
		activityEnded:"活动已结束",
		success:"活动报名成功",
		pleaseRead:"请阅读并同意"
	},
	qa:{
		brief:"简介",
		detail:"详细信息",
		relateDownload:"相关下载",
		relate:"相关问题"
	},
	// 后台菜单
	adminMenu: {
		home:'个人主页',
		information: '个人信息',
		password: '修改密码',
		product: '我的产品',
		download: '下载记录',
		entry: '报名记录',
		feedback: '问题反馈',
		ip: 'IP产品'
	},
	// 后台
	admin: {
		exit: '退出登录',
		slogan: '欢迎登录平台',
		website: '主页',
		messageCenter: '消息中心',
		confirmNewPassword: '确认新密码',
		emailCode: '邮箱验证码',
		save: '保存',
		passwordPlaceholder: '请输入新密码或确认密码',
		reLogin: '密码已修改，请重新登录',
		downloadContent: '下载内容',
		contentType: '内容类型',
		downloadDate: '下载时间',
		handle: '操作',
		back: '返回',
		del:'删除',
		activityInfo: '活动信息',
		stateDate: '开始时间',
		endDate: '结束时间',    
		address: '地址',
		emtryInfo: '报名信息',
		username: '姓名',
		phone: '手机号',
		companyEmail: '企业邮箱',
		company: '公司',
		job: '职位',
		industry: '行业',
		activityName: '活动名称',
		activityState: '活动状态',
		projectName: '项目名称',
		createDate: '创建时间',
		basicInformation: '基本信息',
		companyName: '公司名称',
		ipVisit: 'IP访问',
		productGroup: '产品组',
		limitation: '限制',
		partNumber: '零件编号',
		incomeType: '收入类型',
		projectManager: '项目经理',
		ownerGroup: '所有者组',
		ipSource: 'IP源',
		productType: '产品类型',
		ipType: 'IP类型',
		iPFamily: 'IP家族',
		technology: '工艺',
		agreement: '协议',
		architecture: '体系结构',
		productCategory: '产品类别',
		automaticNaming: '自动命名',
		contractMilestones: '合同里程碑',
		serialNumber: '序号',
		typesOf: '类型',
		finalMSOfTheContract: '合同最终MS',
		milestoneName: '里程碑名称',
		milestoneDescription: '里程碑描述',
		dependencyRelationship: '依赖关系',
		agreedCompletionTime: '约定完成时间',
		updateCompletionTime: '更新完成时间',
		expectedCompletionTime:'预期完成时间',
		actualFinish: '实际完成时间',
		addMilestones: '新增里程碑',
		deliveryStatus: '交付物状态',
		fileNameDescription: '文件名/描述',
		milestoneNumber: '里程碑',
		downloadBtn: '下载',
		deliverables: '交付物',
		uploaded: '上传时间',
		fileName:'文件名',
		version:"版本",
		versionNo:'版本号',
		size:"大小",
		format:'格式',
		releaseTime:"发布时间",
		productName:"产品名称",
		purchasingDate:"购买日期",
		downloadAccess:'下载访问权',
		documentAccess:'文档访问权',
		trainingAccess:'培训访问权',
		viewPermissions:'查看权限',
		doyouwant:'你想做什么？',
		iWantChoose:'我想选择',
		productsOfInterest:'感兴趣的产品',
		iWantToModify:'我想修改',
		currentPassword:'目前的密码',
		iWantToView:'我想查看',
		myDownloadHistory:'我的下载记录',
		myRegistrationRecords:'我的报名记录',
		isThereAnyFeedbackOnMyWorkOrder:'我的工单是否反馈',
		myIPProductProgress:"我的IP产品进度",
		basicInformation:"基本信息",
		isSubscribe:'是否订阅感兴趣的内容推送',
		subscribed:'已订阅',
		unsubscribe:'取消订阅',
		feedback:'反馈',
		feedbackTime:'反馈时间',
		feedbackIssues:'反馈问题',
		supplementaryQuestions:'补充问题',
		supplementaryAdd:'会员补充',
		replenishmentTime:'补充时间',
		problemSummary:'问题概述',
		problemSummaryPlaceholder:'请输入标题',
		problemDetails:'详细描述',
		problemDetailsPlaceholder:'请描述您的问题',
		uploadAttachments:'上传附件',
		addImages:'添加图片',
		submit:'立即提交',
		workOrderTitle:'工单标题',
		questionType:'问题类型',
		problemStatus:'问题状态',
		submissionTime:'提交时间',
		feedbackTime:'反馈时间',
		operate:'操作',
		unread:'未读',
		read:"已读",
		message:"消息",
		messageName:'消息名称',
		messageTime:'消息时间',
		publishedDocuments:'发布文档',
		installFiles:'安装文件',
		enterQuestion: '请输入问题概述',
		enterDetail: '请输入详细描述',
		createDate: '创建日期',
		question:'问题',
		applay:"UVOS回复",
		workOrderId:"工作项ID",
		process:"进度",
		saler:"销售",
		ipName:"IP名称",
		manager:"项目经理",
		protocol:"协议",
		nameAndVersion:"产品名称/版本"
	}
}

export default zh_CN